<template>
  <div>
    <loading
        :active.sync="loading.isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :color="'#8b3434'"
        :loader="loading.loader"
        :height="loading.height"
        :width="loading.width"
        :opacity="loading.opacity">
    </loading>
    <div>
      <div :class="survey.html_class_name">

        <div class="container">
          <div class="all_wrapper flex housemod">
            <div class="scenario_dialog wordsmod">

              <h2 v-if="page.page_no !== 0">{{ survey.label }}</h2>
              <p>{{ survey.sub_label }}</p>

              <transition name="fade" mode="out-in">
                <Bar
                    :key="loadKey()"
                    :bar="survey"
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'Bar'">
                </Bar>
                <SingleChoice
                    :key="loadKey()"
                    :options=survey.options
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'SingleChoice'">
                </SingleChoice>
                <CityAreaDropdown
                    :key="loadKey()"
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'CityAreaDropdown'">
                </CityAreaDropdown>
                <MultipleChoice
                    :key="loadKey()"
                    :options=survey.options
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'MultipleChoice'">
                </MultipleChoice>
                <MultipleChoiceImage
                    :key="loadKey()"
                    :options=survey.options
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'MultipleChoiceImage'">
                </MultipleChoiceImage>
                <BuyHouseIndex
                    :key="loadKey()"
                    :page_no="page.page_no"
                    @update="getNextPage"
                    v-if="survey.vue_component_name === 'BuyHouseIndex'">
                </BuyHouseIndex>
                <EducationFundIndex
                    :page_no="page.page_no"
                    @update="getNextPage"
                    v-if="survey.vue_component_name === 'EducationFundIndex'">
                </EducationFundIndex>
                <DraggableOption
                    :key="loadKey()"
                    :options="survey.options"
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'DraggableOption'">
                </DraggableOption>
                <ChildDropdown
                    :key="loadKey()"
                    :value="survey.value"
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'ChildDropdown'">
                </ChildDropdown>
                <MultipleInput
                    :key="loadKey()"
                    :survey="survey"
                    :options="survey.options"
                    :page_no="page.page_no"
                    v-if="survey.vue_component_name === 'MultipleInput'">
                </MultipleInput>
                <MultipleCheckbox
                    :key="loadKey()"
                    :options="survey.options"
                    :page_no="page.page_no"
                    :tip="survey.tip"
                    v-if="survey.vue_component_name === 'MultipleCheckbox'">
                </MultipleCheckbox>
              </transition>
              <GoNextButton
                  :model="model"
                  :page_no="page.page_no"
                  :component_name="survey.vue_component_name"
                  v-if="survey.vue_component_name.slice(-5) !== 'Index'"
                  @update="getNextPage()"></GoNextButton>
              <ProgressBar
                  :page=page
                  v-if="page.page_no !== 0"></ProgressBar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoNextButton from '@/components/common/go_next_button'
import ProgressBar from '@/components/common/progress_bar'
import SingleChoice from '@/components/common/single_choice'
import MultipleChoice from '@/components/common/multiple_choice'
import CityAreaDropdown from '@/components/common/city_area_dropdown'
import ChildDropdown from '@/components/common/child_dropdown'
import DraggableOption from '@/components/common/draggable_option'
import Bar from '@/components/common/bar'
import BuyHouseIndex from '@/components/scenrio_index/buy_house_index'
import EducationFundIndex from '@/components/scenrio_index/eduaction_fund_index'
import MultipleInput from '@/components/common/multiple_input'
import MultipleCheckbox from '@/components/common/multiple_checkbox'
import MultipleChoiceImage from '@/components/common/multiple_choice_image'


import indexButton from "@/components/common/index_button";
import router from "@/router";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {ModuleScenarioMap} from "@/enum/config";
import {dispatch} from "vuex-pathify";
import GA from "@/func/seo";

export default {
  name: "scenario",
  components: {
    GoNextButton,
    ProgressBar,
    SingleChoice,
    MultipleChoice,
    CityAreaDropdown,
    ChildDropdown,
    Bar,
    BuyHouseIndex,
    EducationFundIndex,
    indexButton,
    DraggableOption,
    MultipleInput,
    MultipleCheckbox,
    MultipleChoiceImage,
    Loading
  },
  data: function () {
    return {
      moduleName: '',
      config: [],
      model: {},
      survey: {
        vue_component_name: 'Index',
      },
      page: {
        page_no: 0,
        total: 0
      },
      loading: {
        isLoading: true,
        height: 180,
        width: 90,
        opacity: 0.95,
        loader: 'dots'
      }
    }
  },
  async created() {
    this.loading.isLoading = true
    setTimeout(() => {
      this.loading.isLoading = false
    }, 800)
    this.moduleName = await store.get('moduleName')
    if (!this.moduleName) {
      await store.commit('moduleName', this.$route.name)
      this.moduleName = await store.get('moduleName')
    }
    await import(`@/assets/css/scenario_${this.moduleName}.css`)
    await store.dispatch('getSurvey', {module: this.moduleName, scenario: ModuleScenarioMap[this.moduleName]})
    await this.init()
  },
  methods: {
    init() {
      store.commit(`${this.moduleName}/postData`, {})
      this.model = store.get(`${this.moduleName}@data.0`)
      this.survey = this.model.survey[0]
      this.page.total = store.get(`${this.moduleName}@data`).length - 1
      this.page.page_no = this.model.page_no
      this.setForGA()
    },
    getNextPage() {
      this.handlePage()
      this.survey = this.model.survey[0]
      if (this.survey.type === 'form') router.push({name: `${this.moduleName}_form`})
      this.page.page_no = this.model.page_no
      this.setForGA()
    },
    handlePage() {
      // 跳頁邏輯
      if (this.model.skip_condition === "TURE_FALSE") {
        if (!Number(store.get(`${this.moduleName}@postData`)[this.model.page_no].value)) {
          for (let i = this.model.page_no + 1; i < this.model.skip_to_page_no; i++) {
            dispatch(`${this.moduleName}/setPostData`, {page_no: i, page_answer: null})
          }
          this.model = store.get(`${this.moduleName}@data`).find(item => item.page_no === (this.model.skip_to_page_no))
          return
        }
      }
      this.model = store.get(`${this.moduleName}@data`).find(item => item.page_no === (this.model.page_no + 1))
    },
    setForGA() {
      let seo = new GA(
          this.survey,
          this.page,
          this.moduleName
      )
      seo.setForGA()
    },
    camelToSnakeCase(str) {
      return str.toString().replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
    },
    snakeToCamel(str) {
      return str.toLowerCase().replace(/([-_][a-z])/g, group =>
          group
          .toUpperCase()
          .replace('-', '')
          .replace('_', '')
      );
    },
    loadKey() {
      return new Date().getTime().toString()
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.vld-shown {
  overflow: hidden;
}

.vld-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;
}

.vld-overlay.is-active {
  display: flex;
}

.vld-overlay.is-full-page {
  z-index: 9999;
  position: fixed;
}

.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}

.vld-overlay .vld-icon, .vld-parent {
  position: relative;
}

</style>

